import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { VariantButton } from '../components/variation-group-v2/variation-group-v2.component';
import { Location } from '@angular/common';
import { VariantValue } from '../models/catalog.model';
@Injectable({
  providedIn: 'root',
})
export class VariantSelectionService {
  /**
   * Represents the user variant selection
   * Key: variant type
   * Value: variant value
   */
  public variantSelection = new Map<string, string>();

  /**
   * Keep record of the variant order to make sure that the
   * variant selection object key generated in the correct order
   * Key: variant type
   * Value: position
   * !this position is maintained by the back end for details please check
   * !https://github.com/American-Mall-Company/catalog/commit/302a5e5038e515836225663cb364061fb35bff9c#diff-7a9805e2bcd94e3c653d2fa7c4fa9a709aa9c2bc6fd598dba488b05883a8e1ab
   */
  public variantTypeOrder = new Map<string, number>();

  public variantOnSelection$: Subject<boolean> = new Subject<boolean>();
  constructor(private location: Location) { }
  public getFormattedSelection() {
    let result = '';
    this.variantTypeOrder.forEach((orderIdx, variantType) => {
      const selection = this.variantSelection.get(variantType);
      if (selection) {
        result += selection + '|';
      }
    });
    return result.substring(0, result.length - 1);
  }

  public getSelectionAsObject() {
    return Object.fromEntries(this.variantSelection);
  }

  public resetMaps() {
    this.variantTypeOrder.clear();
    this.variantSelection.clear();
  }
  public applySelection(variantButtonRecord: Record<string, VariantButton[]>, variantSelectionObj: any) {
    Object.keys(variantButtonRecord).forEach(groupKey => {
      if (variantButtonRecord[groupKey]) {
        variantButtonRecord[groupKey].forEach((btn: any) => {
          btn.selected = btn.value === variantSelectionObj[groupKey];
        });
      }

    });
    return variantButtonRecord;
  }
  public updateSelectionFromGroup(
    selectGroup: Record<string, string | undefined>,
    productCode: string
  ) {
    // 更新内部 Map
    Object.entries(selectGroup).forEach(([key, value]) => {
      if (value) {
        this.variantSelection.set(key, value);
      } else {
        this.variantSelection.delete(key);
      }
    });

    // 生成 queryParams 字符串
    const queryParams = Object.entries(this.variantSelection)
      .filter(([key, value]) => key !== 'code' && value)
      .map(([key, value]) => `${key}=${value}`)
      .join(';');

    // 更新 URL（不跳转）
    this.location.replaceState(`/details/${productCode};${queryParams}`);

    // 通知订阅方
    this.variantOnSelection$.next(true);
  }

  toQueryString(arr: VariantValue[]): string {
    return arr.map(item => `${item.name}=${item.value}`).join(';');
  }
  
  toQueryObject(values: VariantValue[]): { [key: string]: string } {
    return values.reduce((acc, cur) => {
      if (cur.name && cur.value) {
        acc[cur.name] = cur.value;
      }
      return acc;
    }, {} as { [key: string]: string });
  }
}
